export class EventBus<T extends Record<string, any>> {
  private target = new EventTarget()

  on<K extends keyof T>(type: K, listener: (event: CustomEvent<T[K]>) => void) {
    this.target.addEventListener(type as string, listener as EventListener)
  }
  off<K extends keyof T>(type: K, listener: (event: CustomEvent<T[K]>) => void) {
    this.target.removeEventListener(type as string, listener as EventListener)
  }

  once<K extends keyof T>(type: K, listener: (event: CustomEvent<T[K]>) => void) {
    const onceListener = (e: Event) => {
      listener((e as CustomEvent<T[K]>).detail)
      this.target.removeEventListener(type as string, onceListener)
    }
    this.target.addEventListener(type as string, onceListener)
  }

  emit<K extends keyof T>(type: K, payload: T[K]) {
    this.target.dispatchEvent(
      new CustomEvent(type as string, {
        detail: payload,
      })
    )
  }
}
